import { render, staticRenderFns } from "./OrganisationVerification.vue?vue&type=template&id=7ea627dd&scoped=true"
import script from "./OrganisationVerification.vue?vue&type=script&lang=js"
export * from "./OrganisationVerification.vue?vue&type=script&lang=js"
import style0 from "./OrganisationVerification.vue?vue&type=style&index=0&id=7ea627dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea627dd",
  null
  
)

export default component.exports